import axios from "axios";

const api = axios.create({
	baseURL:
		process.env.REACT_APP_API_BASE_URL ||
		"https://pbnsc1mis5.execute-api.eu-west-2.amazonaws.com/prod",
	timeout: 20000,
});

export const readStoredToken = () => {
	const token = localStorage.getItem("idToken");

	if (!token) {
		return null;
	}

	// Older versions stored strings through JSON.stringify. Keep existing
	// sessions usable while writing clean values from now on.
	try {
		return JSON.parse(token);
	} catch {
		return token;
	}
};

api.interceptors.request.use((config) => {
	const token = readStoredToken();

	if (token && !config.headers.Authorization) {
		config.headers.Authorization = token;
	}

	return config;
});

export default api;
